import { SECTION_IDS } from '../lib/links';

/**
 * "Inside the Orbis Platform" — the heading that introduces the report sections.
 *
 * 2026-07 refresh: this used to be a much larger band (an orange pill, a
 * two-paragraph intro, and a tabbed card containing a full dashboard widget).
 * The refresh stripped all of it so the report cards start immediately
 * (commits dc4386f and 2e72b75), leaving just this heading pair. Verified
 * against production, whose `#platform` section contains no image at all.
 *
 * Two consequences worth knowing:
 *  · The duplicate "Inside the Orbis Platform" is gone — ReportSections used to
 *    render a second copy of this heading, and now renders none.
 *  · `intro-widget.png` (~1.5 MB, ~40% of all image bytes) became unreachable
 *    and has been deleted.
 *
 *  · heading   Inter 700, tracking -1px, #1A3B8F (= secondary-700)
 *  · subtitle  Inter 400, #717171
 */
export function PlatformIntro() {
  return (
    <section
      id={SECTION_IDS.platform}
      className="w-full scroll-mt-16 bg-white px-5 pb-2 pt-12 sm:px-6 md:px-8 lg:scroll-mt-24 lg:px-10 lg:pt-16 xl:px-16 2xl:px-[133px]"
    >
      <div className="mx-auto flex max-w-[1654px] flex-col items-start gap-3">
        <h2 className="text-[28px] font-bold leading-[1.2] tracking-[-0.6px] text-secondary-700 sm:text-[34px] lg:text-[40px] lg:leading-[48px] lg:tracking-[-1px]">
          Inside the Orbis Platform
        </h2>
        <p className="text-base leading-6 text-landing-grey sm:text-lg lg:text-2xl">
          End-to-end visibility and control for enterprise-grade System Decommissioning.
        </p>
      </div>
    </section>
  );
}
